/**
 * Strip references to upstream question banks (e.g. "Examtopics") from
 * exam names and descriptions before displaying them. Existing rows in
 * DynamoDB may already contain these strings; this keeps the UI clean
 * without requiring a data migration.
 */
const STRIP_PATTERNS: RegExp[] = [
  // Trailing separators followed by an Examtopics-style mention
  /\s*[-–—|·•:/]\s*examtopics(?:\s*\([^)]*\))?\s*$/i,
  // Standalone trailing "Examtopics ..."
  /\s*examtopics(?:\s*\([^)]*\))?\s*$/i,
];

export function cleanExamText(text?: string | null): string {
  if (!text) return "";
  let out = text;
  for (const re of STRIP_PATTERNS) {
    out = out.replace(re, "");
  }
  return out.trim();
}
